import React, { type ComponentProps } from 'react';
import { BaseIcon } from '@is24at/react-ui-core/Icons';

export const ChevronRight = (props: ComponentProps<typeof BaseIcon>) => (
  <BaseIcon viewBox="0 0 24 24" {...props}>
    <path d="M9 21c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l7.3-7.3-7.3-7.3c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l8 8c.4.4.4 1 0 1.4l-8 8c-.2.2-.4.3-.7.3z" />
  </BaseIcon>
);
